import React from 'react';
// import { featuresTables } from '../../../../data/pagePricingData';
import checkSvg from '../../../../../assets/img/icon/check-02.svg';
import Tooltips from '../../../../Tooltips/Tooltips';

import './FeaturesTable.scss';

import { featuresTables, toolTips } from './constants';

const FeaturesTable = ({ currentLangKey }) => {
  const data = featuresTables[currentLangKey]
  const toolTipsData = toolTips[currentLangKey]

  return (
    <div className="page-pricing__section-comparison__feature-tables">
      <div className="page-pricing__section-comparison__feature-tables__wrapper">
        <table className="page-pricing__section-comparison__feature-tables__wrapper__table">
        <thead>
          <tr>
            <th>{data.usage.tableHead.th1}</th>
            <th>{data.usage.tableHead.th2}</th>
            <th>{data.usage.tableHead.th3}</th>
            <th>{data.usage.tableHead.th4}</th>
            <th>{data.usage.tableHead.th5}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {/* <th><span className="tooltips-root"><span>Projects</span><div className="abc">abc</div></span></th> */}
            <th aria-label="tooltips"><Tooltips title={data.usage.row1.th} tooltips={toolTipsData.project}/></th>
            <td>{data.usage.row1.td1}</td>
            <td>{data.usage.row1.td2}</td>
            <td>{data.usage.row1.td3}</td>
            <td>{data.usage.row1.td4}</td>
          </tr>
          <tr>
          <th aria-label="tooltips"><Tooltips title={data.usage.row2.th} tooltips={toolTipsData.channels}/></th>
            <td>{data.usage.row2.td1}</td>
            <td>{data.usage.row2.td2}</td>
            <td>{data.usage.row2.td3}</td>
            <td>{data.usage.row2.td4}</td>
          </tr>
          <tr>
            <th aria-label="tooltips"><Tooltips title={data.usage.row3.th} tooltips={toolTipsData.teamMembers}/></th>
            <td>{data.usage.row3.td1}</td>
            <td>{data.usage.row3.td2}</td>
            <td>{data.usage.row3.td3}</td>
            <td>{data.usage.row3.td4}</td>
          </tr>
          <tr>
            <th aria-label="tooltips"><Tooltips title={data.usage.row4.th} tooltips={toolTipsData.mau}/></th>
            <td>{data.usage.row4.td1}</td>
            <td>{data.usage.row4.td2}</td>
            <td>{data.usage.row4.td3}</td>
            <td>{data.usage.row4.td4}</td>
          </tr>
          <tr>
            <th aria-label="tooltips"><Tooltips title={data.usage.row5.th} tooltips={toolTipsData.mauMonth}/></th>
            <td>{data.usage.row5.td1}</td>
            <td>{data.usage.row5.td2}</td>
            <td>{data.usage.row5.td3}</td>
            <td>{data.usage.row5.td4}</td>
          </tr>
        </tbody>
      </table>
      </div>

      <div className="page-pricing__section-comparison__feature-tables__wrapper">
        <table className="page-pricing__section-comparison__feature-tables__wrapper__table">
          <thead>
            <tr>
            <th>{data.storage.tableHead.th1}</th>
            <th>{data.storage.tableHead.th2}</th>
            <th>{data.storage.tableHead.th3}</th>
            <th>{data.storage.tableHead.th4}</th>
            <th>{data.storage.tableHead.th5}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{data.storage.row1.th}</th>
              <td>{data.storage.row1.td1}</td>
              <td>{data.storage.row1.td2}</td>
              <td>{data.storage.row1.td3}</td>
              <td>{data.storage.row1.td4}</td>
            </tr>
            <tr>
            <th>{data.storage.row2.th}</th>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
            <tr>
              <th>{data.storage.row3.th}</th>
              <td>{data.storage.row3.td1}</td>
              <td>{data.storage.row3.td2}</td>
              <td>{data.storage.row3.td3}</td>
              <td>{data.storage.row3.td4}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="page-pricing__section-comparison__feature-tables__wrapper">
        <table className="page-pricing__section-comparison__feature-tables__wrapper__table">
          <thead>
            <tr>
            <th>{data.features.tableHead.th1}</th>
            <th>{data.features.tableHead.th2}</th>
            <th>{data.features.tableHead.th3}</th>
            <th>{data.features.tableHead.th4}</th>
            <th>{data.features.tableHead.th5}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{data.features.row1.th}</th>
              <td className="boolean">{data.features.row1.td1}</td>
              <td className="boolean">{data.features.row1.td2}</td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
            <tr>
              <th aria-label="tooltips"><Tooltips title={data.features.row2.th} tooltips={toolTipsData.templates}/></th>
              <td>{data.features.row2.td1}</td>
              <td>{data.features.row2.td2}</td>
              <td>{data.features.row2.td3}</td>
              <td>{data.features.row2.td4}</td>
            </tr>
            <tr>
              <th aria-label="tooltips"><Tooltips title={data.features.row3.th} tooltips={toolTipsData.sandbox}/></th>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
            <tr>
              <th aria-label="tooltips"><Tooltips title={data.features.row4.th} tooltips={toolTipsData.languages}/></th>
              <td>{data.features.row4.td1}</td>
              <td>{data.features.row4.td2}</td>
              <td>{data.features.row4.td3}</td>
              <td>{data.features.row4.td4}</td>
            </tr>
            <tr>
              <th aria-label="tooltips"><Tooltips title={data.features.row5.th} tooltips={toolTipsData.publishServices}/></th>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>

          </tbody>
        </table>
      </div>

      <div className="page-pricing__section-comparison__feature-tables__wrapper">
        <table className="page-pricing__section-comparison__feature-tables__wrapper__table">
          <thead>
            <tr>
            <th>{data.support.tableHead.th1}</th>
            <th>{data.support.tableHead.th2}</th>
            <th>{data.support.tableHead.th3}</th>
            <th>{data.support.tableHead.th4}</th>
            <th>{data.support.tableHead.th5}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{data.support.row1.th}</th>
              <td>{data.support.row1.td1}</td>
              <td>{data.support.row1.td2}</td>
              <td>{data.support.row1.td3}</td>
              <td>{data.support.row1.td4}</td>
            </tr>
            <tr>
              <th>{data.support.row2.th}</th>
              <td>{data.support.row2.td1}</td>
              <td>{data.support.row2.td2}</td>
              <td>{data.support.row2.td3}</td>
              <td>{data.support.row2.td4}</td>
            </tr>
            <tr>
              <th>{data.support.row3.th}</th>
              <td className="boolean">{data.support.row3.td1}</td>
              <td className="boolean">{data.support.row3.td2}</td>
              <td className="boolean">{data.support.row3.td3}</td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
            <tr>
              <th aria-label="tooltips"><Tooltips title={data.support.row4.th} tooltips={toolTipsData.nlp}/></th>
              <td className="boolean">{data.support.row4.td1}</td>
              <td className="boolean">{data.support.row4.td2}</td>
              <td className="boolean">{data.support.row4.td3}</td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
            <tr>
              <th>{data.support.row5.th}</th>
              <td className="boolean">{data.support.row5.td1}</td>
              <td className="boolean">{data.support.row5.td2}</td>
              <td className="boolean">{data.support.row5.td3}</td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
            <tr>
              <th>{data.support.row6.th}</th>
              <td className="boolean">{data.support.row6.td1}</td>
              <td className="boolean">{data.support.row6.td2}</td>
              <td className="boolean">{data.support.row6.td3}</td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
            <tr>
              <th>{data.support.row7.th}</th>
              <td className="boolean">{data.support.row7.td1}</td>
              <td className="boolean">{data.support.row7.td2}</td>
              <td className="boolean">{data.support.row7.td3}</td>
              <td className="boolean"><img src={checkSvg} alt="yes"/></td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  )
}

// const renderHeader = arr => {
//   return  (
//     <thead>
//       {arr.map(item => <th>{item}</th>)}
//     </thead> 
//   )
// }

// const renderBodyRow = arr => (
//   <tr>
//     {arr.map((tcell, index) => {
//     return index===0 
//       ? <th>{tcell}</th>
//       : <td>{tcell}</td>
//     })}
//   </tr>
// )



// const FeaturesTable = () => {
//   return (
//     <>
//       {featuresTables.map((featureTable) => 
//         <table className="page-pricing__section-comparison__feature-table">
//           {featureTable.map((row, index) => {
//               return index===0 
//                 ? renderHeader(row) 
//                 : null
//           })}
//           <tbody>
//             {featureTable.map((row, index) => {
//               return index!==0 ? renderBodyRow(row) : null
//             })}
//           </tbody>
//         </table>
//        )}
//     </>
//   )
// }

export default FeaturesTable